module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/next_hover-904988836e7376fcb597f1f0c6b7b0c3.svg";